// Color definitions for the Heapnosis game

// Node colors
export const nodeColors = {
  // Circle gradient colors
  lightEdge: '#ce93d8',   // Light purple/pink edge
  midPurple: '#9c27b0',   // Medium purple fill
  darkCenter: '#6a1b9a',  // Dark purple center
  transitionPurple: '#8e24aa', // Transition color between mid and dark
  
  // Outline colors
  brightOutline: '#e040fb', // Bright pink/purple outline
  
  // Text colors
  defaultPurple: '#9c27b0', // Default text color (same as mid fill)
  brightPurple: '#f17eff',  // Bright text color for hover/attention states
  
  // UI colors
  background: '#0a0a2a',  // Deep blue background
  primary: '#e36ceb',     // Primary UI color
  secondary: '#bf70f8',   // Secondary UI color
  accent: '#fdd46c',      // Accent color (yellow)
  
  // Swap indication colors
  swapLight: '#ff4d6a',   // Light red/pink for nodes that need swapping
  swapDark: '#cc0022',    // Darker red for nodes that need swapping
  swapBright: '#ff7788',  // Bright red/pink for swap highlight
};

// Export specific color groups for easier access
export const circleColors = {
  lightEdge: nodeColors.lightEdge,
  midPurple: nodeColors.midPurple,
  darkCenter: nodeColors.darkCenter,
  transitionPurple: nodeColors.transitionPurple,
  brightOutline: nodeColors.brightOutline,
};

export const spiralColors = {
  thickSpiral: '#e040fb55', // Mid-pink for thicker base spiral
  thinSpiral: '#f17eff',  // White for thin glowy overlay spiral
};

export const swapColors = {
  light: nodeColors.swapLight,
  dark: nodeColors.swapDark,
  bright: nodeColors.swapBright,
};

export const textColors = {
  default: nodeColors.lightEdge,
  bright: nodeColors.brightPurple,
};

export default nodeColors;